module.exports = __webpack_public_path__ + "static/media/expii2_v3.f295902c.jpg";